module.exports = __webpack_public_path__ + "static/img_1203-63aff5f4b099b1fad536196d6d99f253.webp";